'use client';

import useSWRImmutable from 'swr';
import {useAccountStore} from '../account/account.hooks';
import {AuthRes, auth} from './auth.fetch';
import {useLocation} from '../browser';
import {SearchParams} from '@/types';
import {navigateToAuth} from '@/lib/utils/api.utils';

interface VerifyAuthenticated {
	redirectUrl?: string;
	redirectUrlParams?: SearchParams;
}

export const useAccountVerifyLogin = (locale: string) => {
	const {account, isLoading} = useAccountStore();
	const location = useLocation();
	const isLoggedIn = account?.isLoggedIn;

	//tbd: there's something wrong with the state where isLoading and isLoggedIn are stale
	const verifyAuthenticated = (
		{redirectUrlParams, redirectUrl}: VerifyAuthenticated = {redirectUrlParams: {}}
	) => {
		if (isLoading || isLoggedIn) {
			return true;
		} // Otherwise, !isLoading && !isLoggedIn:

		// Otherwise, build redirect url.
		const newUrl = new URL(location.url);
		for (const param in redirectUrlParams) {
			newUrl.searchParams.set(param, redirectUrlParams[param]);
		}

		navigateToAuth('login', {
			lang: locale,
			redirectUrl: redirectUrl ? redirectUrl : newUrl.toString()
		});

		return false;
	};

	return {
		accountLoading: isLoading,
		isLoggedIn,
		verifyAuthenticated
	};
};

export const useAccountLoginRequired = (locale: string) => {
	const {accountLoading, isLoggedIn, verifyAuthenticated} = useAccountVerifyLogin(locale);
	verifyAuthenticated();
	return {accountLoading, isLoggedIn};
};

export const useAuth = (
	disable?: boolean
): {
	auth?: AuthRes;
	isLoading: boolean;
	error?: string;
} => {
	const {data, error} = useSWRImmutable(!disable ? 'auth' : null, auth, {
		errorRetryCount: 1
	});

	return {
		auth: data,
		isLoading: !data && !error,
		error
	};
};
